// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-info-container {
  width: 100%;
  font-family: "Proxima Nova", sans-serif;
}
.general-info-container .overview, .general-info-container .details {
  background-color: #F9F9F9;
  padding: 24px;
  border-radius: 16px;
}
.general-info-container .overview .header, .general-info-container .details .header {
  color: var(--secondary-color-1);
  font-size: 14px;
  font-weight: 700;
  margin: 0;
}
.general-info-container .overview .description {
  color: #5F5F5F;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
  line-height: 28px;
}
.general-info-container .details {
  color: var(--secondary-color-1);
}
.general-info-container .details .items {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.general-info-container .details .items .item {
  display: flex;
  height: 40px;
  padding: 0 20px;
  border-radius: 8px;
  align-items: center;
  justify-content: space-between;
}
.general-info-container .details .items .item:nth-child(even) {
  background: #F3F3F3;
}
.general-info-container .details .items .item .title, .general-info-container .details .items .item .value {
  font-size: 14px;
  margin: 0;
  color: #5F5F5F;
}`, "",{"version":3,"sources":["webpack://./src/routes/Listing/modules/ListingDetail/modules/Tabs/modules/GeneralInfo/generalInfo.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,uCAAA;AACJ;AAAI;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;AAER;AADQ;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAGZ;AAEQ;EACI,cAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;AAAZ;AAII;EACI,+BAAA;AAFR;AAGQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AADZ;AAEY;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AAAhB;AACgB;EAAoB,mBAAA;AAEpC;AADgB;EACI,eAAA;EACA,SAAA;EACA,cAAA;AAGpB","sourcesContent":[".general-info-container {\r\n    width: 100%;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    .overview, .details { \r\n        background-color: #F9F9F9;\r\n        padding: 24px;\r\n        border-radius: 16px;\r\n        .header {\r\n            color: var(--secondary-color-1);\r\n            font-size: 14px;\r\n            font-weight: 700;\r\n            margin: 0;\r\n        }\r\n    }\r\n\r\n    .overview {\r\n        .description {\r\n            color: #5F5F5F;\r\n            font-size: 14px;\r\n            margin: 0;\r\n            font-weight: 400;\r\n            line-height: 28px;\r\n        }\r\n    }\r\n\r\n    .details {\r\n        color: var(--secondary-color-1);\r\n        .items {\r\n            display: flex;\r\n            flex-direction: column;\r\n            width: 100%;\r\n            .item {\r\n                display: flex;\r\n                height: 40px;\r\n                padding: 0 20px;\r\n                border-radius: 8px;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                &:nth-child(even) { background: #F3F3F3 }\r\n                .title, .value {\r\n                    font-size: 14px;\r\n                    margin: 0;\r\n                    color: #5F5F5F;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
